export const chargingSessionsResource = {
  name: '充電時段 |||| 充電時段',
  fields: {
    id: '時段編號',
    app_session_id: 'App 時段編號',
    user_id: '用戶編號',
    rfid_user_id: 'RFID 用戶編號',
    charger_id: '充電器編號',
    connector_id: '連接器編號',
    site_id: '站點編號',
    session_start_time: '開始時間',
    session_end_time: '結束時間',
    duration_seconds: '持續時間',
    energy_delivered: '已輸送電量',
    meter_start: '起始電表',
    meter_stop: '結束電表',
    payment_status: '付款狀態',
    payment_method: '付款方式',
    total_cost: '總費用',
    initiated_by: '發起方式',
    user_name: '用戶名稱',
    user_phone: '用戶電話',
    user_email: '用戶電郵',
    site_name: '站點名稱',
    charger_name: '充電器名稱',
  },
  list: {
    title: '充電歷史記錄',
    session: '時段',
    user: '用戶',
    site: '站點',
    charger: '充電器',
    startTime: '開始時間',
    type: '類型',
    totalSessions: '時段',
    loadingSessions: '載入時段中...',
    rfidUser: 'RFID 用戶',
    unknownUser: '未知用戶',
  },
  filters: {
    search: '搜尋',
    type: '類型',
    site: '站點',
    charger: '充電器',
    paymentStatus: '付款狀態',
    fromDate: '開始日期',
    toDate: '結束日期',
  },
  types: {
    app: 'App',
    rfid: 'RFID',
    admin: '管理員',
    ocpp: 'OCPP',
    backend_standalone: '後台',
    backend_on_behalf: '代客充電',
    vendor_api: '供應商 API',
  },
  paymentStatuses: {
    completed: '已完成',
    failed: '失敗',
    refunded: '已退款',
    partial_refund: '部分退款',
  },
  // 連結的 app_transactions 列狀態（預授權或扣款）。在「付款」分頁中以
  // chip 顯示於金額旁邊。
  transactionStatuses: {
    pending: '處理中',
    hold: '已預授權',
    released: '已釋放',
    completed: '已完成',
    failed: '失敗',
    cancelled: '已取消',
    refunded: '已退款',
  },
  actions: {
    refresh: '重新整理',
  },
  export: {
    button: '匯出 Excel',
    exporting: '匯出中…',
    succeeded: '已匯出 %{count} 筆充電記錄至 Excel',
    failed: '匯出失敗',
    empty: '目前篩選條件下沒有可匯出的充電記錄',
    truncated: '已匯出共 %{total} 筆中的前 %{exported} 筆。請縮小時間範圍以匯出更多記錄。',
    dateRequired: '請選擇匯出的時間範圍',
    dateOrderInvalid: '開始時間必須早於結束時間',
    sheetName: '充電歷史記錄',
    dialog: {
      title: '匯出充電歷史記錄',
      from: '由',
      to: '至',
      help: '請按充電開始時間選擇匯出範圍。每次匯出最多 %{limit} 筆；若資料超過此數量，請再縮小時間範圍。',
      presets: '快速範圍',
      preset: {
        today: '今天',
        yesterday: '昨天',
        last7days: '最近 7 天',
        last30days: '最近 30 天',
        thisMonth: '本月',
        lastMonth: '上個月',
      },
      confirm: '匯出',
    },
    col: {
      sessionId: '時段編號',
      userName: '用戶名稱',
      userEmail: '用戶電郵',
      userPhone: '用戶電話',
      licensePlate: '車牌號碼',
      chargerId: '充電器編號',
      chargerName: '充電器名稱',
      siteName: '站點',
      startTime: '開始時間',
      endTime: '結束時間',
      duration: '充電持續時間（時:分:秒）',
      idleDuration: '閒置時間（時:分:秒）',
      energyKwh: '已消耗電量（kWh）',
      chargingServiceFee: '充電服務費',
      idleFee: '閒置費用',
      finalCost: '總費用',
      paymentStatus: '付款狀態',
      initiatedBy: '發起方式',
    },
  },
  show: {
    title: '充電時段詳情',
    sessionNumber: '時段',
    invoice: '發票',
    viewOcppLogs: '檢視 OCPP 日誌',
    // Session Overview
    sessionSummary: '時段摘要',
    completedSessionFrom: '已完成時段，時間',
    energyDelivered: '已輸送電量',
    sessionDuration: '時段持續時間',
    averagePower: '平均功率',
    batteryStateOfCharge: '電池電量',
    // Session Info
    sessionInformation: '時段資訊',
    sessionId: '時段編號',
    transactionId: '交易編號',
    invoiceNumber: '發票編號',
    chargingDuration: '充電持續時間',
    chargingStarted: '充電開始時間',
    chargingCompleted: '充電完成時間',
    cableDisconnected: '電纜已斷開',
    fromChargingStartedToCableDisconnect: '從充電開始到電纜斷開',
    idleDuration: '閒置時間（總計）',
    gracePeriod: '寬限期',
    chargeableIdleTime: '計費閒置時間',
    // Charger & Location
    chargerLocation: '充電器與位置',
    siteName: '站點名稱',
    chargerName: '充電器名稱',
    connectorId: '連接器編號',
    address: '地址',
    maxPower: '最大功率',
    // User Info
    userInformation: '用戶資訊',
    userId: '用戶編號',
    name: '姓名',
    email: '電郵',
    phone: '電話',
    vehicle: '車輛',
    vehicles: '車輛',
    licensePlate: '車牌號碼',
    primary: '主要',
    initiatedBy: '發起方式',
    stopReason: '停止原因',
    // Cost Info
    costInformation: '費用資訊',
    energyCost: '電量費用',
    sessionFee: '時段費用',
    timeFee: '時間費用',
    idleFee: '閒置費用',
    discount: '折扣',
    finalCost: '最終費用',
    meterReading: '電量讀數',
    start: '起始',
    end: '結束',
    idle: '閒置',
    grace: '寬限',
    chargeable: '計費',
    minUnit: '分鐘',
    hrUnit: '小時',
    max: '上限',
    free: '免費',
    // Payment Info
    paymentDetails: '付款詳情',
    paymentMethod: '付款方式',
    paymentStatus: '付款狀態',
    preAuthorization: '預授權',
    actualCharged: '實際扣款',
    settlementDate: '結算日期',
    settlementTransaction: '結算交易',
    // Technical Details
    technicalDetails: '技術詳情',
    averageTemperature: '平均溫度',
    errors: '錯誤',
    errorCount: '個錯誤',
    last: '最後',
    // Archive Info
    archiveInformation: '封存資訊',
    archiveMessage: '此時段已被封存，保存期限為',
    archiveMessageDays: '天',
    archiveMessageUnlimited: '無限期',
    archivedAt: '封存時間',
    originalCreated: '原始建立時間',
    dataRetention: '資料保存期',
    days: '天',
    // Tabs
    overview: '概覽',
    analytics: '分析',
    payment: '付款',
    ocppLogs: 'OCPP 日誌',
    technical: '技術',
    // Analytics Tab - Meter Values Charts
    meterReadingsSummary: '電量讀數摘要',
    startOfCharging: '充電開始',
    endOfCharging: '充電結束',
    power: '功率',
    voltage: '電壓',
    current: '電流',
    meter: '電量',
    time: '時間',
    totalReadingsCaptured: '總讀數記錄',
    samples: '樣本',
    showingKeyDataPoints: '顯示',
    keyDataPoints: '關鍵數據點',
    chargingAnalytics: '充電分析',
    detailedMetricsPerformance: '詳細指標與性能數據',
    noChargingCurveData: '此時段沒有可用的充電曲線數據。',
    energy: '電量',
    allMetrics: '所有指標',
    timeMmSs: '時間（分:秒）',
    powerKw: '功率（kW）',
    voltageV: '電壓（V）',
    currentA: '電流（A）',
    energyKwh: '電量（kWh）',
    powerKwEnergyKwh: '功率（kW）/ 電量（kWh）',
    voltageVCurrentA: '電壓（V）/ 電流（A）',
    // OCPP Logs Tab
    ocppTransactionLogs: 'OCPP 交易日誌',
    completeOcppProtocol: '此時段的完整 OCPP 協議通訊流程',
    showingLogEntries: '顯示',
    of: '/',
    logEntries: '條日誌記錄',
    noOcppLogsFound: '找不到此充電時段的 OCPP 日誌。可能的原因：',
    noOcppLogsReason1: 'Elasticsearch 未配置',
    noOcppLogsReason2: '日誌尚未索引',
    noOcppLogsReason3: '時段太舊，日誌已封存',
    timestamp: '時間戳記',
    logLevel: '日誌等級',
    messageType: '訊息類型',
    ocppAction: 'OCPP 動作',
    direction: '方向',
    resource: '資源',
    error: '錯誤',
    request: '請求',
    response: '回應',
    tags: '標籤',
    fullLogData: '完整日誌數據',
    outgoing: '發送 (OCPP 伺服器 → 充電器)',
    incoming: '接收 (充電器 → OCPP 伺服器)',
    responseTo: '回應',
    status: '狀態',
    transactionIdLabel: '交易編號',
    idTag: 'ID 標籤',
    meterStart: '起始電表',
    meterStop: '結束電表',
    errorLabel: '錯誤',
    connector: '連接器',
    config: '配置',
    type: '類型',
    id: '編號',
  },
};

export const chargingSessions = {
  'charging-sessions': chargingSessionsResource,
};
